import sheet from 'theme/listPageSheet';

export default {
  ...sheet,
  header: {
    padding: [0, 20],
    marginBottom: 35,
  },
};
